export default __webpack_public_path__ + "static/media/norse.bold.5efe60ef.otf";